import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../shared/baseQuery"; 

export const shotEvolutionSlice = createApi({
  reducerPath: "shotEvolutionApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getDistinctPlayers: builder.query({
      query: () => "ShotEvolutionReport/distinct-players",
    }),
    getPlayerById: builder.query({
      query: (playerId) => `ShotEvolutionReport/player/${playerId}`,
    }),
  }),
});

export const { useGetDistinctPlayersQuery, useLazyGetPlayerByIdQuery } =
  shotEvolutionSlice;
